export default "/_next/static/images/3f7fa0a98433c51ab9ecd12c30ecf5ce.jpg";